
import { DateTime, Settings } from 'luxon';


import { loadWidget } from '../utils/load-widget';
import { getCookie, setCookie } from '../../utils/cookie-handler';
import { isFavorite, persistFavorite } from '../../utils/favorites';
import simpleTimezone from '../../utils/simple-timezone';
import { getEvents } from '../../utils/api';

Settings.defaultZoneName = 'America/Chicago';

const labels = {
    add: 'Add to Favorites',
    saved: 'Saved to Favorites',
};

const cookies = {
    logged_in: '_bo_logged_in',
    customer_no: 'bo_customer_no',
    login_seen: 'login_seen',
    favorites: 'favorites',
};

loadWidget('favorites-button', {
    props: ['prodSeasonNo', 'perfNo'],
    data: function () {
        return {
            ViewModel: {
                Loading: true,
                HasFavorite: false,
                FavoritesModalActive: false,
                LoginModalActive: false,
                HideWidget: true,
                IsLoggedIn: false,
                Events: [],
                ButtonText: labels.add,
                ProdSeasonNo: null,
                PerfNo: null
            },
        };
    },
    methods: {
        init() {
            const productionNo = parseInt(this.$props.prodSeasonNo, 10);
            const perfNo = parseInt(this.$props.perfNo, 10);

            this.ViewModel.ProdSeasonNo = productionNo;
            this.ViewModel.PerfNo = perfNo;

            if (!productionNo && !perfNo) {
                this.ViewModel.Loading = false;
            } else {
                getEvents().then(response => {
                    if (perfNo) {
                        response = response.filter(item => {
                            return parseInt(item.perf_no, 10) === parseInt(perfNo, 10);
                        });
                    } else {
                        response = response.filter(item => {
                            return parseInt(item.prod_season_no, 10) === parseInt(productionNo, 10);
                        });
                    }

                    const promises = response.map(item => {
                        return isFavorite(item.perf_no).then(status => {
                            const date = DateTime.fromISO(item.perf_date);

                            const time = (
                                date.toFormat('m') > 0 ? date.toFormat('h:mma') : date.toFormat('ha')
                            ).toLowerCase();

                            return {
                                ProdSeasonNo: item.prod_season_no,
                                PerfNo: item.perf_no,
                                Date: `${date.toFormat('EEE MMM d')}, ${time} ${simpleTimezone(date)}`,
                                IsFavorite: status,
                            };
                        });
                    });

                    return Promise.all(promises).then(events => {
                        this.ViewModel.Events = events;
                    });
                }).finally(() => {
                    // Do we have any selected?
                    this.ViewModel.HasFavorite = this.ViewModel.Events.some(item => {
                        return item.IsFavorite;
                    });

                    // If no events supplied found, hide widget
                    this.ViewModel.HideWidget = this.ViewModel.Events.length === 0;

                    // Finished loading
                    this.ViewModel.Loading = false;
                });
            }
        },
        processFavorite: function () {
            if (this.ViewModel.Events.length === 1) {
                // Only one event, no need for popup
                this.toggleEventFavorite(this.ViewModel.Events[0]);
                // See if we need to show login modal
                this.openLoginModal();
            } else {
                // Multiple events, show popup
                this.openFavoritesModal();
            }
        },
        toggleEventFavorite: function (event) {
            // Toggle Event Fav Indicator
            event.IsFavorite = !event.IsFavorite;

            // Persist
            persistFavorite(event.PerfNo, event.IsFavorite);

            this.$root.$emit('favoriteEventUpdated', event);

            this.postUpdateFavoriteStatus();
        },
        postUpdateFavoriteStatus: function () {
            // Check all events in list to see if the button should show a "HasFavorite" state
            const hasFavorite = this.ViewModel.Events.some(item => {
                return item.IsFavorite;
            });

            this.ViewModel.HasFavorite = hasFavorite;

            if (hasFavorite) {
                this.ViewModel.ButtonText = labels.saved;
            } else {
                this.ViewModel.ButtonText = labels.add;
            }
        },
        openFavoritesModal: function () {
            this.ViewModel.FavoritesModalActive = true;
            this.$root.$emit('openFavoritesModal', this.ViewModel, this.toggleEventFavorite, this.closeFavoritesModal);
        },
        closeFavoritesModal: function () {
            this.ViewModel.FavoritesModalActive = false;
            // See if we need to show login modal
            this.openLoginModal();
        },
        openLoginModal: function () {
            if (this.ViewModel.HasFavorite === false) {
                return;
            }

            if (parseInt(getCookie(cookies.login_seen), 10) === 1) {
                return;
            }

            setCookie(cookies.login_seen, 1);
            this.ViewModel.LoginModalActive = true;
            this.$root.$emit('openLoginModal', this.ViewModel, this.closeLoginModal);
        },
        closeLoginModal: function () {
            this.ViewModel.LoginModalActive = false;
        },
        // Updated the event in another instance so just keeping them in-sync
        favoriteEventUpdated: function (event) {
            if (this.ViewModel.PerfNo && this.ViewModel.PerfNo !== event.PerfNo) {
                return;
            }
            if (this.ViewModel.ProdSeasonNo !== event.ProdSeasonNo) {
                return;
            }
            // Use the original Event unless matches the one passed in
            this.ViewModel.Events = this.ViewModel.Events.map(ev => {
                if (
                    ev.PerfNo && ev.PerfNo === event.PerfNo
                    ||
                    !ev.PerfNo && ev.ProdSeasonNo === event.ProdSeasonNo
                ) {
                    return event;
                }
                return ev;
            });

            this.postUpdateFavoriteStatus();
        },
    },
    beforeMount() {
        this.init();
        this.$root.$on('favoriteEventUpdated', this.favoriteEventUpdated);
    }
});
